"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Home = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxConnect = require("redux-connect");

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reactRouter = require("react-router");

var _ads = require("../../redux/modules/ads");

var _Hero = require("../../components/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _HomeAdsPanel = require("../../components/ads/HomeAdsPanel");

var _HomeAdsPanel2 = _interopRequireDefault(_HomeAdsPanel);

var _AdsUtil = require("../../utils/AdsUtil");

var _LicenceExpiredModal = require("../../components/modal/LicenceExpiredModal");

var _LicenceExpiredModal2 = _interopRequireDefault(_LicenceExpiredModal);

var _NotLoggedInModal = require("../../components/modal/NotLoggedInModal");

var _NotLoggedInModal2 = _interopRequireDefault(_NotLoggedInModal);

var _UserUtil = require("../../utils/UserUtil");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = exports.Home = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));

    _this.closeModal = function () {
      _this.setState({ showNotLoggedInModal: false });
    };

    _this.toggleNotLoggedInModal = function () {
      _this.setState({
        showNotLoggedInModal: !_this.state.showNotLoggedInModal
      });
    };

    _this.toggleLicenceExpiredModal = function () {
      _this.setState({
        showLicenceExpiredModal: !_this.state.showLicenceExpiredModal
      });
    };

    _this.state = {
      showLicenceExpiredModal: false,
      showNotLoggedInModal: false,
      notLoggedInMessageShown: false
    };
    _this.closeModal = _this.closeModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var user = this.props.user;

      // customer is logged in but no active paid profile

      if (user && !(0, _UserUtil.isPaidUser)(user)) {
        this.setState({
          showLicenceExpiredModal: true
        });
      }

      // customer is not logged in.
      if (!this.state.notLoggedInMessageShown) {
        if (!user) {
          this.setState({
            showNotLoggedInModal: true,
            notLoggedInMessageShown: true
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          ads = _props.ads,
          soilTypes = _props.soilTypes,
          user = _props.user;
      var _state = this.state,
          showLicenceExpiredModal = _state.showLicenceExpiredModal,
          showNotLoggedInModal = _state.showNotLoggedInModal;

      var userCompanyId = 0;
      if (user) {
        userCompanyId = Number(user.company_id);
      }

      return _react2.default.createElement(
        "div",
        { className: "full-width" },
        _react2.default.createElement(
          "div",
          { className: "content-container" },
          _react2.default.createElement(
            "div",
            { className: "container" },
            _react2.default.createElement(
              "div",
              { className: "row" },
              _react2.default.createElement(_reactHelmet2.default, { title: "Etusivu" }),
              _react2.default.createElement(_Hero2.default, { pushRoute: this.props.pushRoute })
            ),
            _react2.default.createElement(
              "div",
              { className: "row" },
              this.renderLicenseInfo()
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "content-container-section" },
          _react2.default.createElement(
            "div",
            { className: "container" },
            _react2.default.createElement(
              "div",
              { className: "row home-suggestions" },
              _react2.default.createElement(
                "div",
                { className: "home-suggestions-col home-suggestions-col-left" },
                _react2.default.createElement(_HomeAdsPanel2.default, {
                  adType: "receiverAd",
                  soilTypes: soilTypes,
                  ads: userCompanyId > 0 ? (0, _AdsUtil.getThreeNewestAds)("receiverAd", ads, user.company_id) : (0, _AdsUtil.getThreeNewestAdsNotLoggedIn)("receiverAd", ads)
                  //   ads={getThreeNewestAds('receiverAd', ads)}
                })
              ),
              _react2.default.createElement(
                "div",
                { className: "home-suggestions-col home-suggestions-col-right" },
                _react2.default.createElement(_HomeAdsPanel2.default, {
                  adType: "supplierAd",
                  soilTypes: soilTypes
                  // ads={getThreeNewestAds('supplierAd', ads)}
                  , ads: userCompanyId > 0 ? (0, _AdsUtil.getThreeNewestAds)("supplierAd", ads, user.company_id) : (0, _AdsUtil.getThreeNewestAdsNotLoggedIn)("supplierAd", ads)
                })
              )
            ),
            _react2.default.createElement(
              "div",
              { className: "row" },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: "more-ads-link", to: "/ilmoitukset" },
                _react2.default.createElement(
                  "h2",
                  { className: "h4 more-ads-link-text" },
                  "Katso lis\xE4\xE4 ilmoituksia"
                )
              )
            )
          )
        ),
        _react2.default.createElement(_NotLoggedInModal2.default, {
          isShowingModal: showNotLoggedInModal,
          handleClose: this.toggleNotLoggedInModal,
          onRequestClose: this.closeModal
        }),
        _react2.default.createElement(_LicenceExpiredModal2.default, {
          isShowingModal: showLicenceExpiredModal,
          handleClose: this.toggleLicenceExpiredModal
        })
      );
    }
  }, {
    key: "renderLicenseInfo",
    value: function renderLicenseInfo() {
      var user = this.props.user;


      if (user && (0, _UserUtil.isPaidUser)(user)) {
        var todaysDate = (0, _moment2.default)(new Date());
        var paidUntil = (0, _moment2.default)(user.paid_until);
        var diffDays = paidUntil.diff(todaysDate, "days");

        if (diffDays > 7) {
          return null;
        }

        return _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(
            "h4",
            { className: "warning" },
            "K\xE4ytt\xF6oikeutesi vanhenee ",
            diffDays,
            " p\xE4iv\xE4n kuluttua!!."
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(route) {
      var _this2 = this;

      return function () {
        _this2.props.pushRoute(route);
      };
    }
  }]);
  return Home;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object,
  ads: _react.PropTypes.array,
  soilTypes: _react.PropTypes.array.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  text: _react.PropTypes.string
}, _temp);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];

    if (!(0, _ads.isAdsLoaded)(getState())) {
      promises.push(dispatch((0, _ads.loadAds)()));
    }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    ads: state.ads.ads,
    soilTypes: state.ads.soilTypes
  };
}, {
  pushRoute: _reactRouterRedux.push
})(Home));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Home/Home.js
 ** module id = 1215
 ** module chunks = 0
 **/